import { render, staticRenderFns } from "./edit_shortcut.vue?vue&type=template&id=3714045a&scoped=true"
import script from "./edit_shortcut.vue?vue&type=script&lang=js"
export * from "./edit_shortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3714045a",
  null
  
)

export default component.exports